var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReceiptLineWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.66683L4 1.3335L2 2.66683V12.6668C2 13.7714 2.89543 14.6668 4 14.6668H13.3333C14.4379 14.6668 15.3333 13.7714 15.3333 12.6668V10.6668H14V2.66683L12 1.3335L10 2.66683L8 1.3335L6 2.66683ZM12.6667 10.6668H4.66667V12.6668C4.66667 13.035 4.36819 13.3335 4 13.3335C3.63181 13.3335 3.33333 13.035 3.33333 12.6668V3.38041L4 2.93596L6 4.2693L8 2.93596L10 4.2693L12 2.93596L12.6667 3.38041V10.6668ZM13.3333 13.3335H5.88619C5.9599 13.125 6 12.9006 6 12.6668V12.0002H14V12.6668C14 13.035 13.7015 13.3335 13.3333 13.3335Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReceiptLineWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/receipt-line-white.09226e5e.svg";
export { ForwardRef as ReactComponent };